package com.snakesworld.game.repository

import co.touchlab.kermit.Logger

class LoggerRepositoryImpl(
    private val tag: String = "kmpLog",
) : LoggerRepository {
    override fun i(message: String) {
        Logger.i(tag = tag) { message }
    }

    override fun v(message: String) {
        Logger.v(tag = tag) { message }
    }

    override fun d(message: String) {
        Logger.d(tag = tag) { message }
    }

    override fun e(message: String) {
        Logger.e(tag = tag) { message }
    }
}
